var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsaConnecticutClassic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1135 1135",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1058.97 317.376c-10.073-14.139-25.32-22.456-45.281-24.858-3.419-.739-9.888-1.848-18.205-1.848-16.079 0-38.997 4.251-57.294 24.304-20.792 22.825-28.924 59.882-24.211 110.06.647 6.746 1.017 12.845 1.017 18.574.37 26.152.37 93.241-6.838 153.862-.37 2.957-4.343 3.512-5.545.832-2.587-6.007-5.637-11.828-9.333-17.558-17.188-26.799-44.542-47.129-77.07-57.202-14.324-4.436-29.017-6.654-43.617-6.654-18.297 0-36.132 3.604-52.119 10.442-5.822 2.495-12.29-1.571-12.753-7.855-.554-8.687-8.224-15.063-16.911-14.139l-7.023.832c-5.914.647-11.274-3.696-11.736-9.703l-2.957-37.426c-.554-7.393-7.485-12.568-14.693-10.997l-19.683 4.066c-6.284 1.294-11.644 5.267-14.786 10.904-23.195 42.786-57.849 51.565-70.416 53.413l.185-3.974c.462-8.317-6.561-15.248-14.878-14.601l-18.205 1.294c-6.376.462-12.29 3.696-16.079 8.871-28.647 39.274-64.594 43.525-78.641 43.525-1.941 0-3.05-.092-3.05-.092-2.957-.37-5.729-1.479-7.947-3.512-22.271-19.868-53.043-31.142-85.479-31.142-11.828 0-23.842 1.479-35.578 4.343-26.152 6.469-49.624 19.683-67.367 37.518-2.495 2.495-6.746.924-7.116-2.587l-6.191-59.142c-1.109-10.627-10.72-18.297-21.347-16.911L75.546 494.341c-7.578.924-12.845 8.04-11.736 15.525l4.066 26.522c1.201 7.578 7.67 13.215 15.34 13.215h3.512l17.558 170.681-1.571.185c-10.442 1.017-18.112 10.165-17.281 20.607l1.479 18.205c.832 10.073 9.703 17.558 19.776 16.541l129.189-12.198c12.475-1.201 21.347-12.66 19.221-25.043l-1.109-6.561c16.634 7.3 35.023 11.089 54.06 11.089 11.828 0 23.842-1.479 35.578-4.343 24.119-5.914 45.928-17.558 63.116-33.452l-.092 1.386c-.462 15.248 4.528 28.37 14.693 38.905 19.776 20.33 53.598 23.38 72.08 23.38 3.696 0 6.191-.092 7.116-.185l1.109-.092 1.201-.185c40.568-7.023 59.327-28.832 68.014-47.961 2.218-4.99 8.132-7.023 13.03-4.62 11.366 5.452 25.505 8.317 41.954 8.317 15.71 0 28-2.495 28.555-2.587l1.109-.185 1.109-.37c8.964-2.772 17.003-6.376 24.304-10.72 6.469-3.881 14.693-3.234 20.607 1.479 14.139 11.459 30.772 20.238 48.792 25.782 14.324 4.436 29.017 6.654 43.617 6.654a139.57 139.57 0 0 0 29.941-3.234c4.066-.924 7.578 2.772 6.469 6.746a75.545 75.545 0 0 0-2.495 27.076c3.142 37.334 33.914 67.182 71.34 69.307 43.895 2.495 80.396-32.528 80.396-75.868 0-18.759-7.023-36.779-19.314-50.548-4.158-4.713-6.099-10.997-4.898-17.188.37-1.663 32.898-163.565 76.793-227.236 17.003-24.673 28.647-50.548 34.838-76.885 7.762-34.284 5.083-60.806-8.04-79.103zm-385.071 246.55-.092-1.756 1.663-.277c-.554.647-1.109 1.294-1.571 2.033zM550.624 647.28l-11.459 2.218 1.663-36.132 6.561-.277 3.234 34.192z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m100.681 736.547 20.7-1.941-20.7-200.806H83.123l-3.696-24.027 113.202-14.416 23.842 228.714h19.498l3.881 23.195-137.228 13.03z",
    style: {
      fill: "#ffec01"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.265 514.948 101.096-12.937 23.749 227.975h19.868l1.941 11.921-124.846 11.921-1.017-11.921 20.792-1.941-21.809-212.173H88.206z",
    style: {
      fill: "#ed1b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.494 727.214c-49.532 0-91.208-28.832-101.374-70.139-12.753-51.472 26.337-105.532 87.05-120.502a132.44 132.44 0 0 1 31.789-3.881c49.532 0 91.208 28.832 101.374 70.139 6.191 25.135.462 51.565-16.264 74.39-16.449 22.548-41.584 38.905-70.786 46.112-10.535 2.495-21.162 3.881-31.789 3.881z",
    style: {
      fill: "#ffec01"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.8972 -.22141 .22141 .8972 -98.09 143.918)",
    cx: 309.225,
    cy: 618.018,
    rx: 116.3,
    ry: 97.6,
    style: {
      fill: "#ed1b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.385 728.23c-13.03 0-26.152-2.033-38.905-5.914-59.882-18.482-95.829-74.667-80.212-125.215 11.828-38.442 51.195-64.225 97.862-64.225 13.03 0 26.152 2.033 38.905 5.914 59.882 18.482 95.829 74.667 80.212 125.215-11.828 38.442-51.195 64.225-97.862 64.225z",
    style: {
      fill: "#ffec01"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(17.144 854.931 494.597) scale(.92416)",
    cx: 893.889,
    cy: 698.824,
    rx: 116.5,
    ry: 97.5,
    style: {
      fill: "#ed1b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.49 699.398h-1.017l-1.386-.092a13.54 13.54 0 0 1-9.149-4.62c-2.31-2.68-3.419-6.191-3.142-9.703l9.056-115.605c.554-6.931 6.376-12.383 13.307-12.383h1.017l1.386.092c7.393.554 12.845 7.023 12.29 14.416l-9.056 115.605c-.554 6.838-6.376 12.29-13.307 12.29z",
    style: {
      fill: "#ffec01"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m780.909 693.761-9.333-.739c-1.941-.185-3.327-1.848-3.142-3.696l9.703-123.552c.185-1.941 1.848-3.327 3.696-3.142l9.333.739c1.941.185 3.327 1.848 3.142 3.696l-9.703 123.552c-.185 1.848-1.848 3.234-3.696 3.142z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M331.706 701.616c-6.284 0-11.644-4.251-13.03-10.35l-27.168-115.697c-.832-3.512-.185-7.023 1.663-10.073s4.805-5.175 8.317-6.007l1.386-.277c1.017-.277 2.033-.37 3.05-.37 6.284 0 11.644 4.251 13.03 10.35l27.168 115.697c1.663 7.208-2.772 14.416-9.98 16.079l-1.386.277c-1.017.277-2.033.37-3.05.37z",
    style: {
      fill: "#ffec01"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m338.544 694.223-9.056 2.125c-1.848.462-3.696-.739-4.158-2.587l-28.924-123.459c-.462-1.848.739-3.696 2.587-4.158l9.056-2.125c1.848-.462 3.696.739 4.158 2.587l28.924 123.459c.462 1.848-.739 3.789-2.587 4.158z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M492.868 752.904c-15.987 0-45.004-2.403-60.713-18.574-7.116-7.3-10.535-16.541-10.257-27.353l7.578-116.067-19.498-4.528v-19.961l6.654.739s1.756.185 4.805.185c16.541 0 58.495-4.898 91.486-49.994l1.663-2.218 18.759-1.294-3.327 60.713 33.73.647-1.386 21.531-36.964 1.294-7.485 116.067c1.109 2.125 2.957 4.62 4.343 4.62.277 0 7.855-.37 19.683-33.268l1.201-3.327 18.482-2.865.462 6.469c0 .554 2.865 55.723-62.377 66.997l-.277.092h-.277c-.277 0-2.587.092-6.284.092z",
    style: {
      fill: "#ffec01"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.983 573.074s58.773 6.654 101.743-52.212l9.241-.647-3.327 60.159 33.73.647-.647 9.888-36.964 1.294-7.947 122.905s13.215 34.376 35.67-27.723l8.594-1.294s3.327 50.179-57.479 60.806c0 0-71.987 4.62-70.693-39.644l7.947-120.964-19.868-4.62v-8.594z",
    style: {
      fill: "#ed1b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.384 708.085c-34.284 0-54.522-13.307-57.017-37.426l-7.855-116.067-19.961-1.941-2.68-19.776 6.654-.185c2.31-.092 56.278-2.125 88.806-62.099l1.294-2.403 18.39-3.789 4.713 60.621 33.545-3.789 1.386 21.531-36.502 6.191 7.947 116.067c1.294 1.941 3.419 3.974 4.713 3.974.092 0 7.67-.37 15.248-35.67l.739-3.419 17.927-5.267 1.294 6.376c.092.554 10.257 54.799-52.951 74.759l-.277.092-.277.092c-.185 0-11.274 2.125-25.135 2.125z",
    style: {
      fill: "#ffec01"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.71 538.698s59.142-1.201 93.981-65.241l9.056-1.848 4.713 60.066 33.452-3.789.647 9.888-36.502 6.191 8.409 122.905s17.65 32.343 31.697-32.251l8.317-2.403s9.888 49.347-48.885 67.829c0 0-70.786 14.139-75.314-29.941l-8.132-120.964-20.238-1.941-1.201-8.502z",
    style: {
      fill: "#ed1b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m901.597 693.299 2.495-6.191c26.429-64.872 26.706-202.932 26.244-243.685-.092-6.191-.462-12.66-1.109-19.868-4.343-45.558 2.495-78.456 20.145-97.954 14.416-15.802 32.713-19.129 45.558-19.129 7.855 0 13.769 1.294 15.525 1.663 15.71 1.663 27.538 7.855 35.116 18.39 10.35 14.508 12.198 36.687 5.452 65.981-5.637 24.396-16.541 48.515-32.436 71.433-45.65 66.165-78.918 231.486-79.288 233.15l-1.294 6.284-36.409-10.073z",
    style: {
      fill: "#ffec01"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m909.544 689.418 23.749 6.654s33.36-167.354 80.212-235.368c14.508-21.162 25.69-44.449 31.512-69.492 7.947-34.376 6.931-72.819-35.763-77.162 0 0-86.773-23.472-74.297 108.951.647 6.746 1.109 13.584 1.201 20.33.647 41.122.277 180.014-26.614 246.087z",
    style: {
      fill: "#ed1b24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.983 828.125c-33.175 0-60.159-26.984-60.159-60.159s26.984-60.159 60.159-60.159 60.159 26.984 60.159 60.159-26.984 60.159-60.159 60.159z",
    style: {
      fill: "#ffec01"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 902.983,
    cy: 767.966,
    r: 54.152,
    style: {
      fill: "#ed1b24"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaConnecticutClassic);
export default __webpack_public_path__ + "static/media/usa_connecticut_classic.104c9ab5599749bf6b9e29625305bcbe.svg";
export { ForwardRef as ReactComponent };